/** @file cos and sin of n evenly spaced angles 2 pi i / n, computed once through math/trig. */
import { trig } from '@pose2d/math/trig';

/** [cos, sin] of the angles 2 pi i / n for i = 0..n-1 (the values a per-call trig.cos / trig.sin would give). */
export function unitCircle(n: number): [Float64Array, Float64Array] {
  const angle = (i: number): number => (2 * Math.PI * i) / n;
  return [Float64Array.from({ length: n }, (_, i) => trig.cos(angle(i))), Float64Array.from({ length: n }, (_, i) => trig.sin(angle(i)))];
}
